export default __webpack_public_path__ + "static/media/ChickenParmSub.9d22a05a.jpg";